<template>
  <label class="jc-btn md jc-btn-radius uploader-btn" :class="[type]" ref="btn" v-show="support"><slot></slot></label>
</template>

<script>
  import { uploaderMixin, supportMixin } from '../common/mixins'

  const COMPONENT_NAME = 'uploader-btn'

  export default {
    name: COMPONENT_NAME,
    mixins: [uploaderMixin, supportMixin],
    props: {
      directory: {
        type: Boolean,
        default: false
      },
      single: {
        type: Boolean,
        default: false
      },
      attrs: {
        type: Object,
        default () {
          return {}
        }
      },
      type: {
        type: String,
        default: 'btn'
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.uploader.uploader.assignBrowse(this.$refs.btn, this.directory, this.single, this.attrs)
      })
    }
  }
</script>

<style lang="less">
  .uploader-btn {
    .jcy-icon {
      margin-right: 5px;
      font-size: 12px;
      vertical-align: initial;
    }
    position: relative;
    color: #303133;
    background: transparent;
    text-align: center;
    cursor: pointer;
    border: none;
    padding: 0 10px;
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    white-space: nowrap;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.1s cubic-bezier(0.645, 0.045, 0.355, 1);
    border: 1px solid #dcdef6;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    outline: none;
    overflow: hidden;
    vertical-align: middle;
    display: inline-block;
    border-radius: 4px;
  }
  .uploader-btn:hover {
    background-color: rgba(0, 0, 0, .08);
  }
  .uploader-btn.text {
    border: none;
    color: #409bff;
    text-decoration: underline;
    height: auto;
    line-height: unset;
    background: transparent;
    &:hover {
      background: transparent;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/framework/uploader/components/btn.vue